import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFilteredProducts } from '../actions/FilterActions';
import ProductCard from './ProductCard';
import { SimpleProductPageSkeleton } from './HomeSkeletons';
// import { selectBestSellerProducts } from '../selectors/ProductSelector';
import Pagination from './Pagination'

const BestProducts = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);

  const { loading, filteredProducts, count } = useSelector((state) => state.filters);
  // const bestSellerProducts = useSelector(selectBestSellerProducts);
  const productsPerPage = 30;
  const totalPages = Math.ceil(count / productsPerPage);
  // const totalPages = 1;
  useEffect(() => {
    dispatch(fetchFilteredProducts({
      tags: ['BEST SELLER'],
      page: currentPage,
      status: 'published',
      pagination: productsPerPage,
    }));
  }, [dispatch, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  if (loading)
    return (
      <SimpleProductPageSkeleton
        gridClassName="new-products-grid"
        cardCount={15}
        wrapperClassName="new-products-section"
      />
    );
  // if (error) return <div>Error: {error}</div>;

  if (filteredProducts && filteredProducts.length === 0) {
    return (
      <div className="new-products-section">
        <h3 className="new-products-title">Best Sellers</h3>
        <div className="no-new-products-message">
          No best sellers available at the moment.
        </div>
      </div>
    );
  }

  return (
    <div className="new-products-section">
      <h3 className="new-products-title">Best Sellers</h3>
      <p className="new-products-description">Discover what everyone loves</p>
      {filteredProducts && filteredProducts.length > 0 && (
        <div className="new-products-grid">
          {filteredProducts.map((product) => (
            <ProductCard key={product.product_id} product={product} preferredTag="BEST SELLER" />
          ))}
        </div>
      )}
      {/* Pagination Component */}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default BestProducts;


